import { render, staticRenderFns } from "./HeaderForLanding.vue?vue&type=template&id=bdfec40c&scoped=true"
import script from "./HeaderForLanding.vue?vue&type=script&lang=js"
export * from "./HeaderForLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfec40c",
  null
  
)

export default component.exports